import { errorMessage, successMessage } from "../../utils/notificationUtils";
import { OHDR_APIS } from "../../utils/constants";
import Axios from "../../utils/axiosInterceptor";
import { StatusCodes } from "http-status-codes";
import axios from "axios";
import {
  IAllQueryFetchResponse,
  IQueryFilter,
} from "../../interfaces/IPreAuthQuery";
import { errorMessageModal } from "../../utils/modalMessage";

export const GetOHDRDialysisPerformedBy = async (): Promise<any> => {
  try {
    const resp = await Axios.get<any>(OHDR_APIS.OHDR_DIALYSIS_PERFORMED_BY);
    return resp.data;
  } catch (error: any) {
    const errorMsg =
      error?.response?.data?.message ||
      "Cannot fetch OHDR Dialysis Performed By data";
    errorMessage(errorMsg);
    throw new Error(errorMsg);
  }
};

export const GetOHDRNS = async (): Promise<any> => {
  try {
    const resp = await Axios.get<any>(OHDR_APIS.OHDR_NS);
    return resp.data;
  } catch (error: any) {
    const errorMsg =
      error?.response?.data?.message || "Cannot fetch OHDR NS data";
    errorMessage(errorMsg);
    throw new Error(errorMsg);
  }
};

export const GetOHDRAVF = async (): Promise<any> => {
  try {
    const resp = await Axios.get<any>(OHDR_APIS.OHDR_AVF);
    return resp.data;
  } catch (error: any) {
    const errorMsg =
      error?.response?.data?.message || "Cannot fetch OHDR AVF data";
    errorMessage(errorMsg);
    throw new Error(errorMsg);
  }
};

export const GetOHDRHeparin = async (): Promise<any> => {
  try {
    const resp = await Axios.get<any>(OHDR_APIS.OHDR_HEPARIN);
    return resp.data;
  } catch (error: any) {
    const errorMsg =
      error?.response?.data?.message || "Cannot fetch OHDR Heparin data";
    errorMessage(errorMsg);
    throw new Error(errorMsg);
  }
};

export const GetOHDRFullBloodVolume = async (): Promise<any> => {
  try {
    const resp = await Axios.get<any>(OHDR_APIS.OHDR_FULL_BLOOD_VOLUME);
    return resp.data;
  } catch (error: any) {
    const errorMsg =
      error?.response?.data?.message ||
      "Cannot fetch OHDR Full Blood Volume data";
    errorMessage(errorMsg);
    throw new Error(errorMsg);
  }
};

export const GetOHDRBloodTubingCount = async (): Promise<any> => {
  try {
    const resp = await Axios.get<any>(OHDR_APIS.OHDR_BLOOD_TUBING_COUNT);
    return resp.data;
  } catch (error: any) {
    const errorMsg =
      error?.response?.data?.message ||
      "Cannot fetch OHDR Blood Tubing Count data";
    errorMessage(errorMsg);
    throw new Error(errorMsg);
  }
};

export const GetOHDRDialyzerCount = async (): Promise<any> => {
  try {
    const resp = await Axios.get<any>(OHDR_APIS.OHDR_DIALYZER_COUNT);
    return resp.data;
  } catch (error: any) {
    const errorMsg =
      error?.response?.data?.message || "Cannot fetch OHDR Dialyzer Count data";
    errorMessage(errorMsg);
    throw new Error(errorMsg);
  }
};

export const GetOHDRVascularAccessTypes = async (): Promise<any> => {
  try {
    const resp = await Axios.get<any>(OHDR_APIS.OHDR_VASCULAR_ACCESS_TYPES);
    return resp.data;
  } catch (error: any) {
    const errorMsg =
      error?.response?.data?.message ||
      "Cannot fetch OHDR Vascular Access Types data";
    errorMessage(errorMsg);
    throw new Error(errorMsg);
  }
};

export const GetDBPatientDetails = async (payload: any): Promise<any> => {
  try {
    const resp = await Axios.post<any>(
      `${OHDR_APIS.Get_DB_Patient_Details}`,
      payload
    );
    return resp;
  } catch (error: any) {
    const errorMsg =
      error?.response?.data?.error?.message ||
      "Cannot fetch Database Patient Details data";
    errorMessage(errorMsg);
    throw new Error(errorMsg);
  }
};

export const GetDatabasePatientDetails = async ({
  uhidNo,
  healthCareId,
  schemeMetaDataId,
}: {
  uhidNo: string;
  healthCareId: number;
  schemeMetaDataId: string;
}): Promise<any> => {
  try {
    const payload = {
      uhidNo: uhidNo,
      beneficiaryNo: null,
      uhidNoPresent: true,
      healthCareId: healthCareId,
    };
    const resp = await Axios.post<any>(
      `${OHDR_APIS.Get_Database_Patient_Details}/schemeMetaData/${schemeMetaDataId}/withUHID`,
      payload
    );
    return resp;
  } catch (error: any) {
    const errorMsg =
      error?.response?.data?.error?.message ||
      "Cannot fetch Database Patient Details data";
    errorMessage(errorMsg);
    throw new Error(errorMsg);
  }
};

export const GetPortalPatientDetails = async ({
  registrationId,
}: {
  registrationId: string;
}): Promise<any> => {
  try {
    const payload = {
      registrationId: registrationId,
    };
    const resp = await Axios.post<any>(
      OHDR_APIS.Get_Portal_Patient_Details,
      payload
    );
    return resp;
  } catch (error: any) {
    const errorMsg =
      error?.response?.data?.error?.message ||
      "Cannot get Portal Patient Details data";
    errorMessage(errorMsg);
    throw new Error(errorMsg);
  }
};

export const createPatient = async (formData: any) => {
  try {
    const resp: any = await Axios.post<any>(
      OHDR_APIS.OHDR_CREATE_PATIENT,
      formData
    );
    return resp?.data;
  } catch (error: any) {
    const errorMsg =
      error?.response?.data?.error?.message ||
      "Cannot post Patient Details data";
    errorMessage(errorMsg);
    throw new Error(errorMsg);
  }
};

export const getAppointment = async (scheduleId: any) => {
  try {
    const resp: any = await Axios.get<any>(
      `${OHDR_APIS.OHDR_APPOINTMENTS}/${scheduleId}`
    );
    return resp?.data;
  } catch (error: any) {
    const errorMsg =
      error?.response?.data?.error?.message ||
      "Cannot get Appointment Details data";
    errorMessage(errorMsg);
    throw new Error(errorMsg);
  }
};

export const postAppointment = async (
  formData: any,
  userId?: string | number
) => {
  try {
    const resp: any = await Axios.post<any>(
      OHDR_APIS.OHDR_APPOINTMENTS,
      formData,

      {
        headers: {
          ...(userId && { userId }),
          // "Content-Type": "application/json",
        },
      }
    );
    return resp?.data;
  } catch (error: any) {
    const errorMsg =
      error?.response?.data?.error?.message ||
      "Cannot post Appointment Details data";
    errorMessage(errorMsg);
    throw new Error(errorMsg);
  }
};

export const postOhdrVisit = async (formData: any) => {
  try {
    const resp: any = await Axios.post<any>(
      OHDR_APIS.OHDR_VISIT_DETAILS,
      formData
    );
    return resp?.data;
  } catch (error: any) {
    const errorMsg =
      error?.response?.data?.error?.message || "Cannot post ohdr Details data";
    errorMessage(errorMsg);
    throw new Error(errorMsg);
  }
};

export const getOhdrPatientList = async ({
  schemeId,
  healthCareId,
  pageNumber,
  pageSize,
  startDate,
  endDate,
  searchTerm,
  missedOnly,
  assignedToMe,
}: {
  schemeId: any;
  healthCareId: any;
  pageNumber: any;
  pageSize: any;
  startDate?: string;
  endDate?: string;
  searchTerm?: string;
  missedOnly: string;
  assignedToMe: string;
}) => {
  try {
    const resp: any = await Axios.get<any>(OHDR_APIS.OHDR_PATIENT_LIST, {
      headers: {
        "Content-Type": "application/json",
        startDate,
        endDate,
        search: searchTerm,
        // orderBy: "DESC",
        pageNumber: pageNumber - 1 || 0,
        pageSize: pageSize,
        // search: "",
        schemeId: schemeId,
        // status: true,
        // selectedDateType: "DOA",
        healthCareId: healthCareId,
        missedOnly: missedOnly,
        assignedToMe: assignedToMe,
        // all: "",
        // assignedToMe: "",
      },
    });
    return resp?.data;
  } catch (error: any) {
    const errorMsg =
      error?.response?.data?.error?.message ||
      "Cannot get patient Details data";
    errorMessage(errorMsg);
    throw new Error(errorMsg);
  }
};

export const getOhdrVisitDetails = async (visitId: any) => {
  try {
    const resp: any = await Axios.get<any>(
      `${OHDR_APIS.OHDR_PARTICULAR_VISIT_DETAILS}/${visitId}`
    );
    return resp?.data;
  } catch (error: any) {
    if (error?.response?.status === 404) {
      throw new Error("Not Found");
    } else {
      const errorMsg =
        error?.response?.data?.error?.message ||
        "Cannot get visit Details data";
      errorMessage(errorMsg);
      throw new Error(errorMsg);
    }
  }
};

export const postOhdrVisitDetails = async (formData: any) => {
  try {
    const resp: any = await Axios.post<any>(
      `${OHDR_APIS.OHDR_VISIT_DETAILS}`,
      formData
    );
    return resp?.data;
  } catch (error: any) {
    const errorMsg =
      error?.response?.data?.error?.message ||
      "Cannot post ohdr visit Details data";
    errorMessage(errorMsg);
    throw new Error(errorMsg);
  }
};

export const updateOhdrVisitDetails = async (formData: any) => {
  try {
    const resp: any = await Axios.patch<any>(
      `${OHDR_APIS.OHDR_VISIT_DETAILS}`,
      formData
    );
    return resp?.data;
  } catch (error: any) {
    const errorMsg =
      error?.response?.data?.error?.message ||
      "Cannot post ohdr visit Details data";
    errorMessage(errorMsg);
    throw new Error(errorMsg);
  }
};

export const getOhdrParticularVisitDetails = async (visitId: any) => {
  try {
    const resp: any = await Axios.get<any>(
      `${OHDR_APIS.OHDR_VISIT_DETAILS}/visit-id/${visitId}`
    );
    return resp?.data;
  } catch (error: any) {
    const errorMsg =
      error?.response?.data?.error?.message ||
      "Cannot get ohdr visit Details data";
    errorMessage(errorMsg);
    throw new Error(errorMsg);
  }
};

export const getHdrList = async (
  hospitalId: any,
  schemeId: any,
  pageNumber: any,
  pageSize: any,
  startDate?: string,
  endDate?: string,
  searchTerm?: string
) => {
  try {
    const resp: any = await Axios.get<any>(
      `${
        OHDR_APIS.HDR_PATIENT_LIST
      }/hd-patient-list?hospitalId=${hospitalId}&schemeId=${schemeId}&pageNumber=${
        pageNumber - 1
      }&pageSize=${pageSize}&startDate=${startDate}&endDate=${endDate}&search=${searchTerm}`
    );
    return resp?.data;
  } catch (error: any) {
    const errorMsg = error?.response?.data?.error?.message || "Cannot get ohdr";
    errorMessage(errorMsg);
    throw new Error(errorMsg);
  }
};

export const postCheckInCheckOut = async (formData: any) => {
  try {
    const resp: any = await Axios.post<any>(
      `${OHDR_APIS.OHDR_CHECKIN_CHECKOUT}`,
      formData
    );
    return resp?.data;
  } catch (error: any) {
    const errorMsg =
      error?.response?.data?.error?.message ||
      "Cannot post check in or check out";
    errorMessage(errorMsg);
    throw new Error(errorMsg);
  }
};

export const postHdrDetails = async (formData: any) => {
  try {
    const resp: any = await Axios.post<any>(
      `${OHDR_APIS.HDR_VISIT_DETAILS}`,
      formData
    );
    return resp?.data;
  } catch (error: any) {
    const errorMsg =
      error?.response?.data?.error?.message ||
      "Cannot post hdr visit Details data";
    errorMessage(errorMsg);
    throw new Error(errorMsg);
  }
};

export const updateHdrDetails = async (formData: any) => {
  try {
    const resp: any = await Axios.patch<any>(
      `${OHDR_APIS.UPDATE_HDR_VISIT_DETAILS}`,
      formData
    );
    return resp?.data;
  } catch (error: any) {
    const errorMsg =
      error?.response?.data?.error?.message ||
      "Cannot patch hdr visit Details data";
    errorMessage(errorMsg);
    throw new Error(errorMsg);
  }
};

export const getHdrDetails = async (visitId: any) => {
  try {
    const resp: any = await Axios.get<any>(
      `${OHDR_APIS.UPDATE_HDR_VISIT_DETAILS}/${visitId}`
    );
    return resp?.data;
  } catch (error: any) {
    const errorMsg =
      error?.response?.data?.error?.message ||
      "Cannot get hdr visit Details data";
    errorMessage(errorMsg);
    throw new Error(errorMsg);
  }
};

export const getAvailableAppointments = async ({
  hospitalId,
  schemeId,
  date,
  isInfectiousPatient,
}: {
  hospitalId: number;
  schemeId: number;
  date: string;
  isInfectiousPatient: boolean;
}) => {
  try {
    const params = {
      hospitalId,
      schemeId,
      isInfectiousPatient,
      date,
    };

    const resp: any = await Axios.get<any>(`${OHDR_APIS.APPOINTMENTS_SLOTS}`, {
      params: params,
    });

    return resp?.data;
  } catch (error: any) {
    const errorMsg =
      error?.response?.data?.error?.message ||
      "Cannot get available appointments slots";
    errorMessage(errorMsg);
    throw new Error(errorMsg);
  }
};

export const updateAppointmentSlot = async (
  formData: any,
  userId?: string | number
) => {
  try {
    const resp: any = await Axios.patch<any>(
      `${OHDR_APIS.UPDATE_APPOINTMENT_SLOT}`,
      formData,
      {
        headers: {
          ...(userId && { userId }),
          // "Content-Type": "application/json",
        },
      }
    );
    return resp?.data;
  } catch (error: any) {
    const errorMsg =
      error?.response?.data?.error?.message || "Cannot update appointment slot";
    errorMessage(errorMsg);
    throw new Error(errorMsg);
  }
};

export const getAllAttachments = async (visitId: any, caseId: any) => {
  try {
    const resp: any = await Axios.get<any>(
      `${OHDR_APIS.GET_ALL_ATTACHMENTS}/getAllAttachments`,
      {
        headers: {
          visitId: visitId,
          caseId: caseId,
        },
      }
    );
    return resp?.data;
  } catch (error: any) {
    const errorMsg =
      error?.response?.data?.error?.message || "Cannot get all attachments";
    errorMessage(errorMsg);
    throw new Error(errorMsg);
  }
};

export const uploadDocument = async (formData: any) => {
  try {
    const resp: any = await Axios.post<any>(
      `${OHDR_APIS.DOCUMENT_UPLOAD}`,
      formData
    );
    return resp?.data;
  } catch (error: any) {
    const errorMsg =
      error?.response?.data?.error?.message || "Cannot upload document";
    errorMessage(errorMsg);
    if (error?.response?.data?.error?.status === "UNPROCESSABLE_ENTITY") {
      throw error?.response?.data?.error;
    } else {
      throw new Error(errorMsg);
    }
  }
};

export const uploadGeoImage = async (formData: any) => {
  try {
    const resp: any = await Axios.post<any>(
      `${OHDR_APIS.GEO_IMAGE_UPLOAD}`,
      formData
    );
    return resp?.data;
  } catch (error: any) {
    const errorMsg =
      error?.response?.data?.error?.message || "Cannot upload image";
    errorMessage(errorMsg);
    throw new Error(errorMsg);
  }
};

export const deleteUploadedDocumentOHDR = async (deleteForm: any) => {
  try {
    const res = await Axios.post(
      OHDR_APIS.DOCUMENT_DELETE,
      {},
      {
        headers: {
          documentId: deleteForm?.id,
        },
      }
    );
    if (res?.status === StatusCodes.OK) {
      successMessage("Document Deleted successfully");
    }
    return res.data;
  } catch (error) {
    console.error("Failed to delete document:", error);
    errorMessageModal("Cannot Delete document. Please, Try again after sometime");
    throw new Error("Failed to delete document");
  }
};

export const rejectUploadedDocumentOHDR = async (deleteForm: any) => {
  try {
    const res = await Axios.post(
      OHDR_APIS.DOCUMENT_REJECT,
      {},
      {
        headers: {
          documentId: deleteForm?.id,
        },
      }
    );
    if (res?.status === StatusCodes.OK) {
      successMessage("Document Rejected successfully");
    }
    return res.data;
  } catch (error) {
    console.error("Failed to reject document:", error);
    errorMessage("Cannot Reject document. Please, Try again after sometime");
    throw new Error("Failed to reject document");
  }
};

export const getVisitDischarge = async (caseId: any) => {
  try {
    const resp: any = await Axios.get<any>(`${OHDR_APIS.GET_DISCHARGE_DATA}`, {
      headers: {
        // visitId: visitId,
        caseId: caseId,
      },
    });
    return resp?.data;
  } catch (error: any) {
    const errorMsg =
      error?.response?.data?.error?.message || "Cannot get discharge data";
    errorMessage(errorMsg);
    throw new Error(errorMsg);
  }
};

export const createVisitDischarge = async (data: any) => {
  try {
    // Ensure dischargeStatus is set from stage if not already present
    const payload = {
      ...data,
      dischargeStatus: data.dischargeStatus || data.stage || undefined,
    };
    const resp: any = await Axios.post(OHDR_APIS.CREATE_DISCHARGE, payload, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    successMessage("Discharge data saved successfully");
    return resp?.data;
  } catch (error: any) {
    const errorMsg =
      error?.response?.data?.error?.message || "Cannot save discharge data";
    errorMessage(errorMsg);
    throw new Error(errorMsg);
  }
};

export const updateVisitDischarge = async (data: any, caseDischargeId: any) => {
  try {
    const payload = {
      ...data,
      dischargeStatus: data.dischargeStatus || data.stage || undefined,
    };
    const resp: any = await Axios.patch(OHDR_APIS.UPDATE_DISCHARGE, payload, {
      headers: {
        "Content-Type": "application/json",
        caseDischargeId: caseDischargeId,
      },
    });
    successMessage("Discharge data updated successfully");
    return resp?.data;
  } catch (error: any) {
    const errorMsg =
      error?.response?.data?.error?.message || "Cannot update discharge data";
    errorMessage(errorMsg);
    throw new Error(errorMsg);
  }
};

export const getVisitClaim = async (
  caseId: any
  // visitId: any
) => {
  try {
    const resp: any = await Axios.get<any>(`${OHDR_APIS.GET_CLAIM_DATA}`, {
      headers: {
        // visitId: visitId,
        caseId: caseId,
      },
    });
    return resp?.data;
  } catch (error: any) {
    const errorMsg =
      error?.response?.data?.error?.message || "Cannot get claim data";
    errorMessage(errorMsg);
    throw new Error(errorMsg);
  }
};

export const createVisitClaim = async (data: any) => {
  try {
    const resp: any = await Axios.post(OHDR_APIS.CREATE_CLAIM, data, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    successMessage("Claim data saved successfully");
    return resp?.data;
  } catch (error: any) {
    const errorMsg =
      error?.response?.data?.error?.message || "Cannot save claim data";
    errorMessage(errorMsg);
    throw new Error(errorMsg);
  }
};

export const updateVisitClaim = async (data: any, caseClaimId: any) => {
  try {
    const resp: any = await Axios.patch(OHDR_APIS.UPDATE_CLAIM, data, {
      headers: {
        "Content-Type": "application/json",
        caseClaimId: caseClaimId,
      },
    });
    successMessage("Claim data updated successfully");
    return resp?.data;
  } catch (error: any) {
    const errorMsg =
      error?.response?.data?.error?.message || "Cannot update claim data";
    errorMessage(errorMsg);
    throw new Error(errorMsg);
  }
};

export const getStageWiseAttachments = async (visitId: any, schemeId: any) => {
  try {
    const resp: any = await Axios.get<any>(`${OHDR_APIS.GET_STAGE_DOCUMENTS}`, {
      headers: {
        visitId: visitId,
        schemeId: schemeId,
      },
    });
    return resp?.data;
  } catch (error: any) {
    const errorMsg =
      error?.response?.data?.error?.message ||
      "Cannot get stage wise attachments";
    errorMessage(errorMsg);
    throw new Error(errorMsg);
  }
};

export const getSearchPatient = async (patientId: any) => {
  try {
    const resp: any = await Axios.get<any>(`${OHDR_APIS.SEARCH_PATIENTS}`, {
      headers: {
        patientId: patientId,
      },
    });
    return resp?.data;
  } catch (error: any) {
    const errorMsg =
      error?.response?.data?.error?.message || "Cannot get search patient";
    errorMessage(errorMsg);
    throw new Error(errorMsg);
  }
};

export const getScheduleAppointment = async (scheduleId: any) => {
  try {
    const resp: any = await Axios.get<any>(
      `${OHDR_APIS.SCHEDULE_GET_APPOINTMENTS}/${scheduleId}`
    );
    return resp?.data;
  } catch (error: any) {
    const errorMsg =
      error?.response?.data?.error?.message ||
      "Cannot get schedule appointment";
    errorMessage(errorMsg);
    throw new Error(errorMsg);
  }
};

export const tcPdfGeneration = async (payload: any) => {
  try {
    const resp: any = await Axios.post<any>(
      `${OHDR_APIS.TC_GENERATION}`,
      payload
    );
    return resp?.data;
  } catch (error: any) {
    const errorMsg =
      error?.response?.data?.error?.message || "Cannot generate tc pdf";
    errorMessage(errorMsg);
    throw new Error(errorMsg);
  }
};

export const getDayClosureSummary = async (
  date: any,
  hospitalId: any,
  schemeId: any
) => {
  try {
    const payload = {
      date,
      hospitalId,
      schemeId,
    };
    const resp: any = await Axios.post<any>(
      `${OHDR_APIS.DAY_CLOSURE_SUMMARY}`,
      payload
    );
    return resp?.data;
  } catch (error: any) {
    const errorMsg =
      error?.response?.data?.error?.message || "Cannot get day closure summary";
    errorMessage(errorMsg);
    throw new Error(errorMsg);
  }
};

export const pendingPatientDetails = async (
  date: any,
  hospitalId: any,
  schemeId: any
) => {
  try {
    const payload = {
      date,
      hospitalId,
      schemeId,
    };
    const resp: any = await Axios.post<any>(
      `${OHDR_APIS.PENDING_PATIENT_DETAILS}`,
      payload
    );
    return resp?.data;
  } catch (error: any) {
    const errorMsg =
      error?.response?.data?.error?.message ||
      "Cannot get pending patient details";
    errorMessage(errorMsg);
    throw new Error(errorMsg);
  }
};

export const dayClosureSubmit = async (
  date: any,
  hospitalId: any,
  schemeId: any
) => {
  try {
    const payload = {
      date,
      hospitalId,
      schemeId,
    };
    const resp: any = await Axios.post<any>(
      `${OHDR_APIS.DAY_CLOSURE}`,
      payload
    );
    return resp?.data;
  } catch (error: any) {
    const errorMsg =
      error?.response?.data?.error?.message || "Cannot post day closure";
    errorMessage(errorMsg);
    throw new Error(errorMsg);
  }
};

export const postPreAuth = async (data: any) => {
  try {
    const resp: any = await Axios.post<any>(`${OHDR_APIS.POST_PREAUTH}`, data);
    return resp?.data;
  } catch (error: any) {
    const errorMsg =
      error?.response?.data?.error?.message || "Cannot post preauth";
    errorMessage(errorMsg);
    throw new Error(errorMsg);
  }
};

export const updatePreAuth = async (data: any, casePreAuthId: any) => {
  try {
    const resp: any = await Axios.patch<any>(
      `${OHDR_APIS.UPDATE_PREAUTH}`,
      data,
      {
        headers: {
          casePreAuthId,
        },
      }
    );
    return resp?.data;
  } catch (error: any) {
    const errorMsg =
      error?.response?.data?.error?.message || "Cannot update preauth";
    errorMessage(errorMsg);
    throw new Error(errorMsg);
  }
};

export const getPreAuth = async (caseId: any, visitId: any) => {
  try {
    const resp: any = await Axios.get<any>(`${OHDR_APIS.GET_PREAUTH}`, {
      headers: {
        caseId,
        visitId,
      },
    });
    return resp?.data;
  } catch (error: any) {
    const errorMsg =
      error?.response?.data?.error?.message || "Cannot get preauth";
    errorMessage(errorMsg);
    throw new Error(errorMsg);
  }
};

export const getDropdownCounts = async (date: any) => {
  try {
    const payload = {
      localDate: date,
    };
    const resp: any = await Axios.post<any>(
      `${OHDR_APIS.DROPDOWN_COUNTS}`,
      payload
    );
    return resp?.data;
  } catch (error: any) {
    const errorMsg =
      error?.response?.data?.error?.message || "Cannot get dropdown counts";
    errorMessage(errorMsg);
    throw new Error(errorMsg);
  }
};

export const getTimelineDetails = async (caseId: any, visitId: any) => {
  try {
    const resp: any = await Axios.get<any>(`${OHDR_APIS.GET_TIMELINE}`, {
      headers: {
        caseId,
        visitId,
      },
    });
    return resp?.data;
  } catch (error: any) {
    const errorMsg =
      error?.response?.data?.error?.message || "Cannot get timeline";
    errorMessage(errorMsg);
    throw new Error(errorMsg);
  }
};

export const getVisitSchemeStages = async (caseId: any, visitId: any) => {
  try {
    const resp: any = await Axios.get(OHDR_APIS.VISIT_SCHEME_STAGES, {
      headers: {
        caseId,
        visitId,
      },
    });
    return resp?.data;
  } catch (error: any) {
    const errorMsg =
      error?.response?.data?.error?.message || "Cannot get visit scheme stages";
    errorMessage(errorMsg);
    throw new Error(errorMsg);
  }
};

export const getQueries = async (
  caseId: number | string,
  visitId: number | string
) => {
  try {
    const res = await Axios.post(
      OHDR_APIS.GET_QUERIES_OHDR,
      {
        caseId,
        visitId,
      },
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    return res.data;
  } catch (error) {
    throw error;
  }
};

export const createQueryPost = async (
  caseId: number | string,
  visitId: number | string,
  queryData: any
) => {
  try {
    const res = await Axios.post(OHDR_APIS.CREATE_QUERY_OHDR, queryData, {
      headers: {
        caseId,
        visitId,
        "Content-Type": "application/json",
      },
    });
    return res.data;
  } catch (error) {
    throw error;
  }
};

export const replyQueryPost = async (
  caseId: number | string,
  visitId: number | string,
  queryId: number | string,
  replyData: { returnedResponse: string }
) => {
  try {
    const res = await Axios.post(OHDR_APIS.REPLY_QUERY_OHDR, replyData, {
      headers: {
        "Content-Type": "application/json",
        caseId,
        visitId,
        queryId,
      },
    });
    return res.data;
  } catch (error) {
    throw error;
  }
};

export const getDayReport = async ({
  date,
  hospitalId,
  schemeId,
}: {
  date: string;
  hospitalId: number;
  schemeId: number;
}) => {
  return axios.post(
    OHDR_APIS.GET_DAY_REPORT,
    {
      date: date,
      hospitalId: hospitalId,
      schemeId: schemeId,
    },
    {
      headers: { "Content-Type": "application/json" },
    }
  );
};

export const getMonthlyReport = async ({
  startDate,
  endDate,
  hospitalId,
  schemeId,
}: {
  startDate: string;
  endDate: string;
  hospitalId: number;
  schemeId: number;
}) => {
  return axios.post(
    OHDR_APIS.GET_MONTHLY_REPORT,
    {
      startDate: startDate,
      endDate: endDate,
      hospitalId: hospitalId,
      schemeId: schemeId,
    },
    {
      headers: { "Content-Type": "application/json" },
    }
  );
};

export const getDocumentDeficiencyQues = async (documentId: any) => {
  try {
    const resp: any = await Axios.get<any>(OHDR_APIS.DOCUMENT_DEFICIENCY_QUES, {
      headers: {
        document_id: documentId,
      },
    });
    return resp?.data;
  } catch (error: any) {
    const errorMsg =
      error?.response?.data?.error?.message ||
      "Cannot get document deficiency questions";
    errorMessage(errorMsg);
    throw new Error(errorMsg);
  }
};

export const markDropCall = async (avId: number | string) => {
  try {
    const resp: any = await Axios.post(
      `${OHDR_APIS.MARK_DROP_CALL}`,
      {},
      {
        headers: {
          avId: avId,
        },
      }
    );
    successMessage("Marked as Drop Call successfully");
    return resp?.data;
  } catch (error: any) {
    const errorMsg =
      error?.response?.data?.error?.message || "Cannot mark drop call";
    errorMessage(errorMsg);
    throw new Error(errorMsg);
  }
};

export const markDropClaim = async (avId: number | string) => {
  try {
    const resp: any = await Axios.post(
      `${OHDR_APIS.MARK_DROP_CLAIM}`,
      {},
      {
        headers: {
          avId: avId,
        },
      }
    );
    successMessage("Marked as Drop Claim successfully");
    return resp?.data;
  } catch (error: any) {
    const errorMsg =
      error?.response?.data?.error?.message || "Cannot mark drop claim";
    errorMessage(errorMsg);
    throw new Error(errorMsg);
  }
};

export const assignToMe = async (avId: number | string) => {
  try {
    const headers: any = {
      avId: avId,
    };

    const resp: any = await Axios.post(
      `${OHDR_APIS.ASSIGN_TO_ME}`,
      {},
      {
        headers,
      }
    );

    return resp?.data;
  } catch (error: any) {
    const errorMsg =
      error?.response?.data?.error?.message || "Cannot assign to you";
    errorMessage(errorMsg);
    throw new Error(errorMsg);
  }
};

export const postDocumentDeficiency = async (values: any) => {
  try {
    const resp: any = await Axios.post(
      `${OHDR_APIS.POST_DOCUMENT_DEFICIENCY}`,
      values
    );
    successMessage("Document deficiency submitted successfully");
    return resp?.data;
  } catch (error: any) {
    const errorMsg =
      error?.response?.data?.error?.message ||
      "Cannot submit document deficiency";
    errorMessage(errorMsg);
    throw new Error(errorMsg);
  }
};

export const fetchQueriesNephro = async (
  filters: IQueryFilter,
  healthCareId: number
): Promise<IAllQueryFetchResponse> => {
  try {
    const res: any = await Axios.get(`${OHDR_APIS.GET_QUERY_LIST}`, {
      headers: {
        "Content-Type": "application/json",
        endDate: filters.endDate,
        orderBy: filters.orderBy,
        pageNumber: filters.pageNumber.toString(),
        pageSize: filters.pageSize.toString(),
        search: filters.searchTerm || "",
        startDate: filters.startDate,
        state: filters.state ? filters.state.map(String) : null,
        scheme: filters.scheme ? filters.scheme.map(String) : null,
        visitType: filters.visitType
          ? filters.visitType.map(String)
          : undefined,
        status: filters.status,
        stage: filters.stage,
        selectedDateType: filters.selectedDateType,
        healthCareId: healthCareId,
      },
    });
    const response = res?.data;
    if (!res?.error) {
      return {
        stagesCount: response.data.stagesCount,
        queryResponseList: response.data.queriesDataList,
        totalElements: response.data.totalElements,
        totalPages: response.data.totalPages,
        status: response.status,
        overallQueryCount: response.data.overallQueryCount,
        visitStageId: response.data.queryStage,
      };
    } else {
      return {
        errorMessage: "Cannot fetch all queries",
        status: res?.status,
      };
    }
  } catch (error) {
    console.error("Error fetching all queries:", error);
    throw new Error("Cannot fetch all queries");
  }
};

export const getShiftClosureSummary = async (
  date: any,
  shift: any,
  hospitalId: any,
  schemeId: any
) => {
  try {
    const payload = {
      date,
      shift,
      hospitalId,
      schemeId,
    };
    const resp: any = await Axios.post<any>(
      `${OHDR_APIS.SHIFT_CLOSURE_SUMMARY}`,
      payload
    );
    return resp?.data;
  } catch (error: any) {
    const errorMsg =
      error?.response?.data?.error?.message ||
      "Cannot get shift closure summary";
    errorMessage(errorMsg);
    throw new Error(errorMsg);
  }
};

export const shiftPendingPatientDetails = async (
  date: any,
  shift: any,
  hospitalId: any,
  schemeId: any
) => {
  try {
    const payload = {
      date,
      shift,
      hospitalId,
      schemeId,
    };
    const resp: any = await Axios.post<any>(
      `${OHDR_APIS.SHIFT_PENDING_PATIENT_DETAILS}`,
      payload
    );
    return resp?.data;
  } catch (error: any) {
    const errorMsg =
      error?.response?.data?.error?.message ||
      "Cannot get pending patient details";
    errorMessage(errorMsg);
    throw new Error(errorMsg);
  }
};

export const shiftClosureSubmit = async (
  date: any,
  shift: any,
  hospitalId: any,
  schemeId: any
) => {
  try {
    const payload = {
      date,
      shift,
      hospitalId,
      schemeId,
    };
    const resp: any = await Axios.post<any>(
      `${OHDR_APIS.SHIFT_CLOSURE}`,
      payload
    );
    return resp?.data;
  } catch (error: any) {
    const errorMsg =
      error?.response?.data?.error?.message || "Cannot post shift closure";
    errorMessage(errorMsg);
    throw new Error(errorMsg);
  }
};

export const generateConsolidatedBillPdf = async (caseId: number) => {
  try {
    const resp = await Axios.post(OHDR_APIS.CONSOLIDATED_BILL_PDF, { caseId });
    return resp.data;
  } catch (error: any) {
    const errorMsg =
      error?.response?.data?.message ||
      "Failed to generate consolidated bill PDF";
    errorMessage(errorMsg);
    throw new Error(errorMsg);
  }
};

export const deleteAppointmentVisit = async (
  avId: any,
  hospitalId: any,
  userId: any
) => {
  try {
    const resp = await Axios.delete(OHDR_APIS.DELETE_APPOINTMENT_VISIT, {
      headers: {
        avId: avId,
        hospitalId: hospitalId,
        userId: userId,
      },
    });
  } catch (error: any) {
    const errorMsg =
      error?.response?.data?.message || "Failed to delete appointment visit";
    errorMessage(errorMsg);
    throw new Error(errorMsg);
  }
};

export const addAppointmentVisit = async (
  hospitalId: number,
  userId: number,
  asId: number,
  scheduledDate: string,
  scheduledTime: string
) => {
  try {
    const payload = {
      asId: asId,
      scheduledDate: scheduledDate,
      scheduledTime: scheduledTime,
    };
    const resp = await Axios.post(OHDR_APIS.ADD_APPOINTMENT_VISIT, payload, {
      headers: {
        hospitalId: hospitalId,
        userId: userId,
      },
    });
    successMessage("Appointment visit added successfully");
    return resp.data;
  } catch (error: any) {
    const errorMsg =
      error?.response?.data?.message || "Failed to add appointment visit";
    errorMessage(errorMsg);
    throw new Error(errorMsg);
  }
};

export const getSessionsDocuments = async (caseId: any) => {
  try {
    const resp = await Axios.get(OHDR_APIS.SESSIONS_DOCUMENTS, {
      headers: {
        caseId: caseId,
      },
    });
    return resp.data;
  } catch (error: any) {
    const errorMsg =
      error?.response?.data?.message || "Failed to fetch session documents";
    errorMessage(errorMsg);
    throw new Error(errorMsg);
  }
};

export const getCalendarDetails = async (
  hospitalId: any,
  calendarMonth: any,
  calendarYear: any
) => {
  try {
    const resp = await Axios.get(OHDR_APIS.CALENDAR_DETAILS, {
      params: {
        hospitalId: hospitalId,
        month: calendarMonth,
        year: calendarYear,
      },
    });
    return resp.data;
  } catch (error: any) {
    const errorMsg =
      error?.response?.data?.message || "Failed to fetch calendar details";
    errorMessage(errorMsg);
    throw new Error(errorMsg);
  }
};

export const sendToQC = async (visitId: number) => {
  try {
    const res = await Axios.patch(
      OHDR_APIS?.SEND_TO_QC,
      {},
      {
        headers: {
          visitId: visitId,
        },
      }
    );
    return res?.data;
  } catch (error: any) {
    const errorMsg = error?.response?.data?.message || `Failed to send to QC`;
    errorMessage(errorMsg);
    throw new Error(errorMsg);
  }
};

export const approveOrRejectVisit = async (
  visitId: number,
  isApproved: boolean
) => {
  try {
    const res = await Axios.patch(
      OHDR_APIS?.APPROVE_OR_REJECT_VISIT,
      {
        visitId: visitId,
        isApproved: isApproved,
      }
      // {
      //   headers: {
      //     visitId: visitId,
      //     isApproved: isApproved,
      //   },
      // }
    );
    return res?.data;
  } catch (error: any) {
    const errorMsg =
      error?.response?.data?.message ||
      `Failed to ${isApproved ? "approve" : "reject"} visit`;
    errorMessage(errorMsg);
    throw new Error(errorMsg);
  }
};
